module["exports"] = ["კორპ. ##", "შენობა ###"];